import * as Sentry from '@sentry/vue'
const SENTRY_DSN = 'https://43af22615b3940ae990833b552c2a1cd@o283739.ingest.sentry.io/5852968'

const trackIssue = (payload = {}) => {
  let { response = {} } = payload
  const { data: responseData = {} } = response
  const stringifiedData = JSON.stringify(responseData)
  let sectionBody = stringifiedData.toLowerCase().includes('dinetime')
    ? 'DineTime API'
    : 'Generic API'
  let messageText = `${sectionBody} error (${response.status})`

  Sentry.withScope((scope) => {
    scope.setLevel('warning')
    scope.setTag('section', sectionBody)
    responseData.error && scope.setTag('errorText', responseData.error)
    responseData.message && scope.setTag('messageText', responseData.message)
    scope.setExtra('data', response)
    scope.setFingerprint([
      messageText
    ])
    Sentry.captureMessage(messageText)
  })
}

const trackIssueCustom = (payload = {}) => {
  let { title, section, data, tags } = payload

  Sentry.withScope((scope) => {
    scope.setLevel('warning')
    scope.setTag('section', section)
    if (tags) {
      for (const [key, data] of Object.entries(tags)) {
        key && scope.setTag(key, data)
      }
    }

    scope.setExtra('data', data)
    scope.setFingerprint([ title ])
    Sentry.captureMessage(title)
  })
}

export default async ({ Vue, router, store }) => {
  !process.env.DEV && Sentry.init({
    Vue,
    dsn: SENTRY_DSN,
    integrations: [
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router)
      }),
      new Sentry.Replay()
    ],

    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 0.2,
    release: 'atbl-widget@' + (process.env.COMMIT_HASH || 'localhost-version'),
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      'Non-Error exception captured',
      'Non-Error promise rejection captured',
      'Illegal invocation',
      'Cannot redefine property: BetterJsPop',
      'evaluating \'bg.LPPlatform\'',
      'undefined is not an object (evaluating \'window.webkit.messageHandlers\')', // Reference to this issue: https://github.com/getsentry/sentry-javascript/issues/3040
      'undefined is not an object (evaluating \'window.webkit.messageHandlers[a].postMessage\')',
      'Can\'t find variable: instantSearchSDKJSBridgeClearHighlight', // Reference to this issue: https://github.com/RecordReplay/devtools/issues/3618
      'Identifier \'change_ua\' has already been declared',
      'undefined is not an object (evaluating \'KLContentObject.scannedUrls[checkStatus.url] = {}\')',
      'undefined is not an object (evaluating \'p.manager\')',
      'undefined is not an object (evaluating \'i.selectionEnd\')',
      'undefined is not an object (evaluating \'__gCrWeb.instantSearch'
    ],
    denyUrls: [
      // Facebook flakiness
      /graph\.facebook\.com/i,
      // Facebook blocked
      /connect\.facebook\.net\/en_US\/all\.js/i,
      // Woopra flakiness
      /eatdifferent\.com\.woopra-ns\.com/i,
      /static\.woopra\.com\/js\/woopra\.js/i,
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
      /^chrome-extension:\/\//i,
      // Other plugins
      /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
      /webappstoolbarba\.texthelp\.com\//i,
      /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
      /webkit-masked-url/i
    ],
    beforeBreadcrumb (breadcrumb, hint) {
      if (breadcrumb.category === 'ui.click') {
        const target = hint.event.target
        if (target.ariaLabel) breadcrumb.message = target.ariaLabel
      }
      return breadcrumb
    }
  })

  Vue.prototype.$trackIssue = trackIssue
  Vue.prototype.$trackIssueCustom = trackIssueCustom
}

export { trackIssue, trackIssueCustom }
